import { Component, computed, inject, Signal } from '@angular/core';
import { DataItemTemplate } from '../../../templates/data-item-template/data-item-template';
import { IconType } from '../../icon/icon';
import { ChronoPipe } from '../../../pipes/chrono-pipe';
import { ProgressIcon } from '../../progress-icon/progress-icon';
import { ApiService } from '../../../services/api-service';
import { TrainingModeType } from '../../../models/training-mode.model';

@Component({
  selector: 'li[app-duration-data-block-item]',
  imports: [DataItemTemplate, ProgressIcon],
  template: `
    <app-data-item-template [dataBlock]="dataBlock()">
      @if (trainingMode() === 'originalSpeed') {
        <app-progress-icon icon="timer" [size]="iconSize()" [percent]="percent()" />
      } @else {
        <app-progress-icon [size]="iconSize()" [icon]="progressIcon()" [percent]="percent()" />
      }
      <p class="name">{{ timerSeconds() }}</p>
      <p class="value">{{ timerHoursMinutes() }}</p>
    </app-data-item-template>
  `,
  styleUrl: './duration-data-block-item.scss',
})
export class DurationDataBlockItem extends DataItemTemplate {
  private readonly apiService: ApiService = inject(ApiService);
  private readonly chronoPipe: ChronoPipe = new ChronoPipe();

  readonly trainingMode: Signal<TrainingModeType> = computed(
    () => this.webSocketService.contentInformation()?.trainingMode || 'originalSpeed',
  );

  readonly time: Signal<number> = computed(() => this.broadcastData()?.time || 0);

  readonly timerSeconds: Signal<string> = computed(() => {
    return ':' + this.chronoPipe.transform(this.time()).split(':')[2];
  });
  readonly timerHoursMinutes: Signal<string> = computed(() => {
    const hours: string = this.chronoPipe.transform(this.time()).split(':')[0];
    const minutes: string = ':' + this.chronoPipe.transform(this.time()).split(':')[1];
    return hours + minutes;
  });

  readonly percent: Signal<number> = computed(() => (this.time() / this.totalDuration()) * 100);

  readonly progressIcon: Signal<IconType> = computed(() => {
    return this.rate() < 0.8 ? 'play_slow' : this.rate() > 1.2 ? 'play_speed' : 'play';
  });

  private readonly rate: Signal<number> = this.webSocketService.rate;
  private readonly totalDuration: Signal<number> = computed(
    () => this.apiService.scenicInformation()?.duration || 0,
  );
}
